/**
 * Per-post metadata: SEO, pull image (optional), and author reference.
 * New journal entries: add a slug key here + a route + blocks module — no layout/CSS edits.
 *
 * CommonJS exports so Node prerender can require(); CRA still imports via webpack interop.
 *
 * Fields:
 * - pullImageSrc / pullImageCaption / pullImageAlt — omit or use empty string for no pull figure.
 * - ogPublishedAt — ISO 8601 for article:published_time (Open Graph).
 * - ogImageSrc — optional absolute or root-relative URL; defaults to pullImageSrc, then site OG image.
 * - ogImageAlt — optional; defaults to pullImageAlt then document title (social card alt text).
 */
const BLOG_POSTS = {
  'why-i-created-orivonai': {
    slug: 'why-i-created-orivonai',
    documentTitle: 'Why I Created OrivonAI — OrivonAI',
    metaDescription:
      'Seven years, six losses, two children through surrogacy — why Vanessa Mosbacker built OrivonAI.',
    authorId: 'vanessa-mosbacker',
    dateLine: 'April 29, 2026',
    pullImageSrc: '/images/blog/founder-amelie.png',
    pullImageCaption: 'Me and Amélie, 2024.',
    pullImageAlt: 'Vanessa Mosbacker holding her daughter Amélie',
    ogPublishedAt: '2026-04-29T00:00:00Z',
    ogImageAlt: 'Vanessa Mosbacker with her daughter Amélie',
  },
  /** Stub for regression: inherits layout, bio, optional pull image omitted */
  'journal-layout-stub': {
    slug: 'journal-layout-stub',
    documentTitle: 'Journal layout stub — OrivonAI',
    metaDescription: 'Placeholder entry exercising BlogPostLayout pull image hooks and author bio.',
    authorId: 'vanessa-mosbacker',
    dateLine: 'May 1, 2026',
    pullImageSrc: '',
    pullImageCaption: '',
    pullImageAlt: '',
    ogPublishedAt: '2026-05-01T00:00:00Z',
    ogImageAlt: 'OrivonAI — journal layout preview',
  },
};

module.exports = { BLOG_POSTS };
